/* eslint-disable @typescript-eslint/no-empty-function */
import { palette } from "lib/miolo";
import ContentSectionDescriptionLine from "components/company/sections/ContentSectionDescriptionLine";
import ContentSectionHeading from "components/company/sections/ContentSectionHeading";
import StaticContentSection from "components/company/StaticContentSection";

import type { IBrazilianCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/BrazilianCompanyIssuerTopLevel.generated";

interface IKeyCustomersSectionProps {
  keyCustomers: NonNullable<IBrazilianCompanyIssuerTopLevelFragment["keyCustomers"]>;
}

export default function KeyCustomersSection({ keyCustomers }: IKeyCustomersSectionProps) {
  return (
    <div>
      <StaticContentSection primaryColor={palette.fiord} className="gap-y-3">
        <div className="col-span-12">
          <ContentSectionHeading>Principais Clientes</ContentSectionHeading>

          <ContentSectionDescriptionLine>
            Confira se algum cliente foi responsável por pelo menos 10% da Receita Líquida total.
          </ContentSectionDescriptionLine>
        </div>

        <div className="col-span-12">
          <p className="m-0 rounded bg-neutral-100 p-4 text-base font-medium text-slate-700">
            {keyCustomers.description}
          </p>
        </div>

        <div className="col-span-12">
          <span className="text-sm font-medium tracking-wider text-slate-500">
            Ano de Referência: <strong>{keyCustomers.yearOfReference}</strong>
          </span>
        </div>
      </StaticContentSection>
    </div>
  );
}
